import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AuthService } from '@core/http/auth.service';
import { DefaultResponse } from '@core/models/Http/DefaultResponse';
import Swal from 'sweetalert2';
import { NgIf } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpMesageHandlerService } from '@core/service/http-mesage-handler';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    RouterLink,
    NgIf,
  ],
})
export class ForgotPasswordComponent implements OnInit {
  email: string = '';
  usr: string = '';

  constructor(
    private authService: AuthService,
    private router: Router,
    private httpMsgHandler: HttpMesageHandlerService
  ) {}

  ngOnInit(): void {}

  sendResetPasswordEmail(): void {
    const email = this.email.trim();
    const usr = this.usr.trim();

    if (!email || !usr) return;

    this.authService.sendResetPasswordEmail(email, usr).subscribe({
      next: (res: DefaultResponse<string>) => {
        Swal.fire({
          icon: 'success',
          title: String(res.code),
          html: res.message,
        }).then(() => {
          this.router.navigate(['/authentication/signin']).then();
        });
      },
      error: (err: HttpErrorResponse) => {
        this.httpMsgHandler.handleMsg(err);
      },
    });
  }
}
